import asyncContainer from '../containers/asyncContainer';
import Typeahead from './Typeahead.react';
export default asyncContainer(Typeahead);